import { useGetTrendingReasonsLinkForQuantify } from '@modules/feed/hooks';
import { InsightsRounded } from '@mui/icons-material';
import { Button, ButtonProps, Tooltip } from '@mui/material';
import { Link } from 'react-router-dom';
import { createAnalyticsTracker } from 'v2/analytics/events';

export const trackOpenInQuantifyEvent =
  createAnalyticsTracker('openInQuantify');

interface SeeTopReasonInQuantifyButtonProps {
  shouldShowCooccurringDataPoints: boolean;
  variant?: ButtonProps['variant'];
}

export const SeeTopReasonInQuantifyButton = ({
  shouldShowCooccurringDataPoints,
  variant = 'outlined',
}: SeeTopReasonInQuantifyButtonProps) => {
  const quantifyLink = useGetTrendingReasonsLinkForQuantify({
    shouldShowCooccurringDataPoints,
  });

  return (
    <Tooltip
      title={!quantifyLink ? 'Disabled due to unsupported filters' : null}
      placement="top"
    >
      <Button
        variant={variant}
        size="medium"
        startIcon={<InsightsRounded />}
        target="_blank"
        component={Link}
        disabled={!quantifyLink}
        to={quantifyLink ?? ''}
        onClick={() => {
          trackOpenInQuantifyEvent({
            eventName: 'Feed Page - Open Top Reasons in Quantify Clicked',
          });
        }}
      >
        Open in Quantify
      </Button>
    </Tooltip>
  );
};
